import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { IDropdownButton, IDropdownLinks } from '@common/interfaces/header-menu.interface';
import { IButton } from '@common/interfaces/button.interface';
import { MENU_DROPDOWN, SHORTCUT_BUTTONS } from '@common/constants/header.constants';
import { NavigationService } from '@services/navigation/navigation.service';
import { HOME_ROUTE } from '@common/constants/routes.constants';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent implements OnInit {
  public open: boolean;
  public menuDropdown: IDropdownButton[];
  public shortcutButtons: IButton[];
  public itemSelected: IDropdownButton;
  public homeRoute: string;
  public tcvRoute: string;

  constructor(
    private menuCtrl: MenuController,
    private navService: NavigationService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.open = false;
    this.menuDropdown = MENU_DROPDOWN;
    this.shortcutButtons = SHORTCUT_BUTTONS;
    this.homeRoute = HOME_ROUTE;
    this.tcvRoute = environment.TCV_SITE;
  }

  public setOpen(open: boolean) {
    this.open = open;
  }

  async ngOnInit() {
    if (isPlatformBrowser(this.platformId)) { await this.menuCtrl.enable(true); }
  }

  public async openSideMenu() {
    await this.menuCtrl.open();
  }

  public get itemValid() {
    return this.itemSelected && this.itemSelected.dropdownLinks && this.itemSelected.dropdownLinks.length > 0;
  }

  public async closeSideMenu(url?: string) {
    await this.menuCtrl.close();
    this.setOpen(false);
    this.itemSelected = null;
    this.navService.goTo(url);
  }

  public setItem(item: IDropdownButton) {
    if (item && item.route !== '') { return this.closeSideMenu(item.route); }
    this.itemSelected = item;
  }

  public menuButtonClass(dropdownLinks: IDropdownLinks) {
    return dropdownLinks ? 'btn btn-menu-header-mobile' : 'btn btn-menu-header-mobile left';
  }

  public menuIconClass(dropdownLinks: IDropdownLinks) {
    return dropdownLinks ? 'icon i-chevron-right' : '' ;
  }

  public redirect(url: string) {
    this.navService.goTo(url);
  }

}
